import { OptionModel } from 'services/models/model';
import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';
import { KinshipDegreeType, KinshipDegreeTypeEnum } from 'services/enums/kinshipDegreeType.enum';

export class EmployeeDependentModel extends Model implements IModel<EmployeeDependentModel> {
  name: string = '';
  birthDate: string = '';
  rg: string = '';
  cpf: string = '';
  kinshipDegree: KinshipDegreeType = 'Child';
  sex: number = 0;
  employeeId: string | undefined = undefined;

  get kinshipDegreeLabel(): string {
    return KinshipDegreeTypeEnum.getBy(this.kinshipDegree)?.label ?? '';
  }

  static create(input: any): EmployeeDependentModel {
    return ObjectMapper.deserialize<EmployeeDependentModel>(EmployeeDependentModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
